import {ChartDataset, ChartDatasetProperties, ChartType} from 'chart.js';
import {dashCaseToCamelCase} from '@angular/compiler/src/util';

interface SingleColorPallete {
  value: string;
}

interface MultipleColorPallete {
  vehiclePrice: string;
  fuel: string;
  maintenance: string;
  insurance: string;
  patent: string;
  infrastructure: string;
  discounts: string;
  tco: string;
}

export enum PalleteIds {
  DIESEL = 'dieselColors',
  ELECTRIC = 'electricColors',
  HYDROGEN = 'hydrogenColors',
}

type ColorPallete = SingleColorPallete | MultipleColorPallete;
type ColorPalleteList = Record<PalleteIds, MultipleColorPallete>;
type ColorList = Record<PalleteIds, SingleColorPallete>;


const tcoColorPalletes: ColorPalleteList = {
  dieselColors: {
    vehiclePrice: '#3B3838',
    fuel: '#767171',
    maintenance: '#AEAAAA',
    insurance: '#BFBFBF',
    patent: '#D9D9D9',
    infrastructure: '#000',
    discounts: '#111',
    tco: '#737373'
  },
  electricColors: {
    vehiclePrice: '#385623',
    fuel: '#4D7731',
    maintenance: '#63973F',
    insurance: '#A5D37B',
    patent: '#A6C34E',
    infrastructure: '#BBD076',
    discounts: '#111',
    tco: '#737373'
  },
  hydrogenColors: {
    vehiclePrice: '#073763',
    fuel: '#1F4E79',
    maintenance: '#25A0B6',
    insurance: '#2BBBD3',
    patent: '#7CD5E4',
    infrastructure: '#C8EEF4',
    discounts: '#111',
    tco: '#737373'
  }
};

const categoryColorPalletes: ColorList = {
  dieselColors: {
    value: '#737373',
  },
  electricColors: {
    value: '#A6C34E'
  },
  hydrogenColors: {
    value: '#25A0B6'
  }
};

const titleColors: ColorList = {
  dieselColors: {
    value: '#737373',
  },
  electricColors: {
    value: '#A6C34E'
  },
  hydrogenColors: {
    value: '#2D8BBA'
  }
};

export const getTcoColorPallete = (palleteId: PalleteIds): MultipleColorPallete => tcoColorPalletes[palleteId];

const getSingleColor = (palleteId: PalleteIds, colorList: ColorList): string => colorList[palleteId].value;

export const getCategoryColor = (palleteId: PalleteIds): string => getSingleColor(palleteId, categoryColorPalletes);
export const getTitleColor = (palleteId: PalleteIds): string => getSingleColor(palleteId, titleColors);

export const getDataValue = (dataset: ChartDataset<'bar' | 'line' | 'scatter' | 'bubble' | 'pie' | 'doughnut' | 'polarArea' | 'radar'>,
                             dataIndex: number): number => {
  const value = dataset.data[dataIndex];
  return Array.isArray(value) ? (value.length !== 2 ? -1 : value[1] - value[0]) : value as number;
};
